const appEnv = {
  PUB_MODE: "r5-security",
  PUB_API_GATEWAY_ENDPOINT_COMMON: "https://bip1abmqhh.execute-api.ap-northeast-1.amazonaws.com/r5-security",
  PUB_CONTENTS_BUCKET: "xxxxx-contents-xxxxx",
  PUB_S3_BUCKET_ENDPOINT: null,
  PUB_AUTH_MFA_ENABLED: false,
  PUB_AUTH_ENDPOINT: "https://4aeltqksf5.execute-api.ap-northeast-1.amazonaws.com/dev",
  PUB_IDENTITY_POOL_ID: "ap-northeast-1:f0ba74c4-1229-4a3a-8403-cee93fbeab02",
  PUB_AUTHORIZATION_AUTH_ENDPOINT: "https://4aeltqksf5.execute-api.ap-northeast-1.amazonaws.com/dev",
  PUB_USER_POOL_ID: "ap-northeast-1_cOaze6IOc",
  PUB_CLIENT_ID: "88vcb7gekt4a95sob0u0ra8n9",
  PUB_USER_POOL_ID_WITH_MFA: "ap-northeast-1_xxxxxxxxx",
  PUB_CLIENT_ID_WITH_MFA: "xxxxxxxxxxxxxxxxxxxxxxxx",
  PUB_DUP_AUTH_MFA_ENABLED: false,
  PUB_DUP_AUTH_ENDPOINT: "https://06kqv0sq0c.execute-api.ap-northeast-1.amazonaws.com/dev",
  PUB_DUP_IDENTITY_POOL_ID: "ap-northeast-1:49816933-82f2-41cb-bfa6-fd3858cbc448",
  PUB_DUP_AUTHORIZATION_AUTH_ENDPOINT: "https://06kqv0sq0c.execute-api.ap-northeast-1.amazonaws.com/dev",
  PUB_DUP_USER_POOL_ID: "ap-northeast-1_VmNPv8muI",
  PUB_DUP_CLIENT_ID: "2ke9igf05hagblrnln89b0s767",
  PUB_DUP_USER_POOL_ID_WITH_MFA: "ap-northeast-1_oHhc7XfCX",
  PUB_DUP_CLIENT_ID_WITH_MFA: "2ef0s8d22plcqr6h1jgpfrijgb",
  PUB_API_GATEWAY_ENDPOINT_DUP: "https://kak4cedx0j.execute-api.ap-northeast-1.amazonaws.com/r5-security",
  PUB_API_GATEWAY_ENDPOINT_OPERATION: "https://2n6yts7thj.execute-api.ap-northeast-1.amazonaws.com/r5-security",
  PUB_API_GATEWAY_ENDPOINT_PROPSCR: "https://d1dum80lw56f9p.cloudfront.net"
};

export default appEnv;
